// Code for the build a bundle
document.addEventListener('DOMContentLoaded', function () {
    const $template = document.querySelector(".bundle-template");

    if ($template){
        console.log('Bundle template script loaded');
        // Function to attach event listeners
        function attachEventListeners () {
            const $bundleSummary = $template.querySelector(".bundle-summary");
            const $productCards = $template.querySelectorAll(".bundle-product-card");
            const $summaryCards = $template.querySelectorAll(".bundle-summary-card");
            const $resetCartButton = $template.querySelector(".bundle-reset-cart-button");
            const $stickyTrigger = $template.querySelector(".bundle-summary__sticky-trigger");
            const $closeSummaryButton = $template.querySelector(".bundle-summary__close-button");

            // Add to cart buttons
            $productCards.forEach(($card) => {
                const $addToCartButton = $card.querySelector(".bundle-product-card__add-to-cart");  
                $addToCartButton.addEventListener("click", function () {
                    const productId = this.getAttribute("data-product-id");
                    addToCart(productId, 1);
                });
            });

            // Summary card buttons
            if ($summaryCards) {
                $summaryCards.forEach(($card) => {
                    const $removeButton = $card.querySelector(".bundle-summary-card__remove-button");
                    const $increaseButton = $card.querySelector(".increase-qty");
                    const $decreaseButton = $card.querySelector(".decrease-qty");
                    const currentQuantity = parseInt($card.querySelector(".current-qty").innerHTML);
                    const lineItemKey = $card.getAttribute("data-line-item-key");

                    console.log('find elements: ', $removeButton, $increaseButton, $decreaseButton, currentQuantity);    

                    // Remove line item
                    $removeButton.addEventListener("click", function () {
                        removeLineItemFromCart(lineItemKey);
                    });

                    // Increase quantity
                    $increaseButton.addEventListener("click", function () {
                        increaseQuantity(lineItemKey, currentQuantity);
                    });

                    // Decrease quantity
                    $decreaseButton.addEventListener("click", function () {
                        decreaseQuantity(lineItemKey, currentQuantity);
                    });
                })
            }

            // Reset cart button
            if ($resetCartButton) {
                $resetCartButton.addEventListener("click", function () {
                    resetCart();
                });
            }

            // Sticky trigger button
            if ($stickyTrigger) {
                $stickyTrigger.addEventListener("click", function () {
                    $bundleSummary.classList.toggle("active");

                    // Persist state in sessionStorage
                    if ($bundleSummary.classList.contains("active")) {
                        sessionStorage.setItem('bundleSummaryActive', 'true');
                    } else {
                        sessionStorage.setItem('bundleSummaryActive', 'false');
                    }
                });
            }

            // Close summary button
            if ($closeSummaryButton) {
                $closeSummaryButton.addEventListener("click", function () {
                    $bundleSummary.classList.remove("active");
                    sessionStorage.setItem('bundleSummaryActive', 'false');
                });
            }


            // Restore summary state from sessionStorage
            const wasActive = sessionStorage.getItem('bundleSummaryActive');
            if (wasActive === 'true') {
                $bundleSummary.classList.add("active");
            }
        }

        // Function to add product to cart
        function addToCart (productId, quantity) {
            $template.classList.add('is-loading');
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: productId,
                    quantity: quantity
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log('Product added to cart:', data);
                // Optionally, update cart UI here
                renderBundle();
            })
            .catch((error) => {
                console.error('Error adding product to cart:', error);
                $template.classList.remove('is-loading');
            });
        };

        // Reset the entire cart (empties it)
        function resetCart() {
            $template.classList.add('is-loading');
            fetch('/cart/clear.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
            .then(response => response.json())
            .then(data => {
                console.log('Cart reset:', data);
                renderBundle(); // optional UI refresh
            })
            .catch(error => {
                console.error('Error resetting cart:', error);
                $template.classList.remove('is-loading');
            });
        };

        // Remove a specific line item from the cart
        function removeLineItemFromCart(lineItemKey) {
            $template.classList.add('is-loading');
            fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: lineItemKey,
                    quantity: 0
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log('Line item removed:', data);
                renderBundle();
            })
            .catch(error => {
                console.error('Error removing line item:', error);
                $template.classList.remove('is-loading');
            });
        };

        // Increase quantity of a specific line item by 1
        function increaseQuantity(lineItemKey, currentQuantity) {
            $template.classList.add('is-loading');

            fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: lineItemKey,
                    quantity: currentQuantity + 1
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log('Quantity increased:', data);
                renderBundle();
            })
            .catch(error => {
                console.error('Error increasing quantity:', error);
                $template.classList.remove('is-loading');
            });
        };

        // Decrease quantity of a specific line item by 1
        function decreaseQuantity(lineItemKey, currentQuantity) {
            const newQuantity = currentQuantity > 1 ? currentQuantity - 1 : 0;
            $template.classList.add('is-loading'); // fade-out on update start

            fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: lineItemKey,
                    quantity: newQuantity
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log('Quantity decreased:', data);
                renderBundle();
            })
            .catch(error => {
                console.error('Error decreasing quantity:', error);
                $template.classList.remove('is-loading');
            });
        };

        // Function to render the updated bundle
        function renderBundle() {
            const section = document.querySelector(".bundle-template");
            if (!section) return;


            const sectionId = section.dataset.sectionId;
            let newSectionData;

            fetch(`${window.location.pathname}?sections=${sectionId}`)
                .then(response => response.json())
                .then(data => {
                    newSectionData = data[sectionId];
                })
                .then(() => {
                    section.innerHTML = newSectionData;
                })
                .then(() => {
                    attachEventListeners();
                })
                .catch(err => console.error('Error refreshing bundle section:', err))
                .finally(() => {
                    // Let the new DOM “exist” before we fade back in
                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            section.classList.remove('is-loading');
                        });
                    });
                });
        }

        attachEventListeners();

        // Select all elements whose class contains "kl-teaser"
        const teasers = document.querySelectorAll('[class*="kl-private"]');
        console.log('found teasers: ', teasers);
        teasers.forEach(teaser => {
            teaser.style.display = 'none';
        });
    }
});